export enum FilterTypeEnum {
    ALL,
    SIMPLE,
    NEWSLETTER,
}
